export interface IROI_FORMULA {
  invested: number;
  returned: number;
  investmentPeriod: number;
}

export const ROI_FORMULA = ({
  invested,
  returned,
  investmentPeriod,
}: IROI_FORMULA) => {
  if (invested < 1 || invested > 1e10 || returned < 1 || returned > 1e10) {
    const emptyRes = 0;
    return {
      totalGain: emptyRes.toFixed(2),
      roi: emptyRes.toFixed(2),
      simpleAnnual: emptyRes.toFixed(2),
      compundAnnual: emptyRes.toFixed(2),
    };
  }
  const amountInvested = invested;
  const amountReturned = returned;
  const time = investmentPeriod;

  const gainOnInvestment = amountReturned - amountInvested;
  const returnOnInvestment =
    ((amountReturned - amountInvested) / amountInvested) * 100;
  const simple = returnOnInvestment / time;
  const compound =
    (Math.pow(amountReturned / amountInvested, 1 / time) - 1) * 100;

  return {
    totalGain: gainOnInvestment.toFixed(2),
    roi: returnOnInvestment.toFixed(2),
    simpleAnnual: simple.toFixed(2),
    compundAnnual: compound.toFixed(2),
  };
};
